import { type TrackedListItem } from './AccessModal';
import { OWNERS_TYPE } from './constants';
import { type AccountOwnerListResponse } from './types';

export const groupByEntitlementType = (
  data: TrackedListItem[]
): Record<string, TrackedListItem[]> =>
  data.reduce<Record<string, TrackedListItem[]>>((acc, item) => {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (!acc[item.tracker.type]) {
      acc[item.tracker.type] = [];
    }

    acc[item.tracker.type].push(item);

    return acc;
  }, {});

export const getOwnersType = (key: number) => {
  if (key === 2) {
    return OWNERS_TYPE.USERGROUP;
  }

  if (key === 3) {
    return OWNERS_TYPE.MACHINE;
  }

  return OWNERS_TYPE.USER;
};

export const getKeyValue = (
  item: AccountOwnerListResponse,
  type: (typeof OWNERS_TYPE)[keyof typeof OWNERS_TYPE]
) => {
  if (type === OWNERS_TYPE.USER) {
    return item.id;
  }

  if (type === OWNERS_TYPE.USERGROUP) {
    return item.usergroupkey;
  }

  return null;
};
